module.exports = __webpack_public_path__ + "static/media/BuiltSmartBtn.e2273929.svg";